import helper from '../helpers/ApiUrlHelper.js';
export default {
  confirm(jobalertId, jobalertToken) {
    return fetch(`${helper.apiUrl()}/jobalert/confirm`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        jobalertId,
        jobalertToken
      })
    });
  },

  signup(jobalertData) {
    return fetch(`${helper.apiUrl()}/jobalert/signup`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jobalertData)
    });
  },

  unsubscribe(jobalertId, jobalertToken) {
    return fetch(`${helper.apiUrl()}/jobalert/unsubscribe`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        jobalertId,
        jobalertToken
      })
    });
  }
};
